export const handleUnknownError = (error: unknown) => {
    let errorMessage = 'unknown Error'
    if (typeof error === 'string') {
        errorMessage = error
    } else if (error instanceof Error) {
        errorMessage = error.message
    }
    return errorMessage
}
